import { FetchOptions, Header } from "~/types";

function getRandomRequestId(): string {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
}

export async function hubbleFetch(
  url: string,
  method: string,
  headers?: HeadersInit,
  body?: any,
  options?: FetchOptions
): Promise<Response> {
  try {
    let completeHeaders: HeadersInit = {
      [Header.AppVersion]: "10000",
      [Header.RequestId]: getRandomRequestId(),
      ...headers,
    };

    if (options?.isRequestBodyJson ?? true) {
      completeHeaders = {
        ...completeHeaders,
        [Header.ContentType]: "application/json",
      };
    }

    let response;
    if (method == "GET") {
      response = await fetch(url, {
        method,
        headers: completeHeaders,
      });
    } else {
      response = await fetch(url, {
        method,
        body:
          (options?.isRequestBodyJson ?? true)
            ? JSON.stringify(body ?? {})
            : (body ?? {}),
        headers: completeHeaders,
      });
    }

    return response;
  } catch (e) {
    throw e;
  }
}
